







































































import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import IntegerInput from 'components/IntegerInput.vue'
import AnswersEditor from 'components/presenter/item/topic/editor/AnswersEditor.vue'

@Component({
  components: {
    FormSlide,
    IntegerInput,
    AnswersEditor
  }
})
export default class ItemTopicSlidesEditorFormOrder extends Mixins(MixinForm) {

  get order () {
    const order: Json[] = []
    const answers = Object.values(this.slide.answers || {}).sort((a, b) => (a as Json).sort - (b as Json).sort) as Json[]
    for (const answer of answers) {
      if (this.correct.indexOf(answer.id) === 0) {
        break;
      }
      if (!answer.deleted) {
        order.push(answer)
      }
    }
    return order
  }

  getCorrectAnswer (answer: Json) {
    return this.order.indexOf(answer) + 1
  }

  setCorrectAnswer (answer: Json) {
    if (this.correct.indexOf(answer.id) === 0) {
      this.setCorrect(null)
    } else {
      this.setCorrect([answer.id])
    }
  }
}
